const roleTypes = {
  ADMIN: "Admin",
  AGENCY: "Agency",
  MERCHANT: "Merchant"
}

export default roleTypes;